import React from 'react';
import { Plus, Handshake } from 'lucide-react';
import { partners, sponsors } from '../mock';
import { useLang } from '../LangContext';

const PartnerLogo = ({ name, logo }) => (
  <div className="bg-white border border-slate-200 rounded-2xl px-5 py-3 flex items-center gap-3 min-w-[180px] shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300">
    {logo ? (
      <img src={logo} alt={name} className="w-8 h-8 object-contain shrink-0" />
    ) : (
      <span className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-100 to-blue-50 flex items-center justify-center text-blue-700 font-black text-[14px]">{name.charAt(0)}</span>
    )}
    <span className="font-black tracking-wide text-slate-800 text-[14px]">{name}</span>
  </div>
);

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative z-10 max-w-[1400px] mx-auto px-6 pb-16">
      {/* Partners */}
      <div className="section-title mt-14">
        <div className="line" />
        <div className="pill"><Handshake className="w-4 h-4 text-blue-600" /> {t.partners}</div>
        <div className="line" />
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {partners.map((p) => <PartnerLogo key={p.name} name={p.name} logo={p.logo} />)}
      </div>

      {/* Sponsors */}
      <div className="section-title mt-12">
        <div className="line" />
        <div className="pill">{t.sponsors}</div>
        <div className="line" />
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {sponsors.map((s, i) => (
          <div key={i} className="bg-white border border-slate-200 rounded-2xl px-6 py-4 flex items-center gap-3 min-w-[200px] shadow-sm">
            {s.status === 'SOON' ? (
              <>
                <span className="w-7 h-7 rounded-md bg-gradient-to-br from-pink-500 to-purple-600 text-white flex items-center justify-center font-black text-[12px]">M</span>
                <span className="font-black tracking-wide text-slate-800 text-[13px]">{s.name}</span>
                <span className="ml-auto text-[10px] font-extrabold text-blue-600 bg-blue-50 border border-blue-100 rounded-full px-2 py-0.5">SOON</span>
              </>
            ) : (
              <>
                <span className="w-7 h-7 rounded-full bg-slate-100 flex items-center justify-center text-slate-400"><Plus className="w-4 h-4" /></span>
                <span className="font-bold tracking-wide text-slate-500 text-[13px]">{t.sponsors.includes('COMING') ? 'COMING' : (t.sponsors.includes('PRÓX') ? 'PRÓXIMO' : 'À VENIR')}</span>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="mt-12 text-center text-[12px] text-slate-400">
        © {new Date().getFullYear()} Domino Arena. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
